export const AUTH_START  = "AUTH_START"
export const AUTH_FAIL  = "AUTH_FAIL"
export const AUTH_SUCCESS  = "AUTH_SUCCESS"
export const LOGOUT  = "LOGOUT"
export const RIDIRECT = "RIDIRECT"
export const CLEAR_ERROR ="CLEAR_ERROR"
export const REGISTER_START = "REGISTER_START"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_FAIL = "REGISTER_FAIL"
export const GET_ACADEMIC_DETAILS_START = "GET_ACADEMIC_DETAILS_START"
export const GET_ACADEMIC_DETAILS_FAIL = "GET_ACADEMIC_DETAILS_FAIL"
export const GET_ACADEMIC_DETAILS_SUCCESS = "GET_ACADEMIC_DETAILS_SUCCESS"
export const GET_COLLEGE_DETAILS_START = "GET_COLLEGE_DETAILS_START"
export const GET_COLLEGE_DETAILS_FAIL = "GET_COLLEGE_DETAILS_FAIL"
export const GET_COLLEGE_DETAILS_SUCCESS = "GET_COLLEGE_DETAILS_SUCCESS"
export const GET_COURSE_DETAILS_START = "GET_COURSE_DETAILS_START"
export const GET_COURSE_DETAILS_FAIL = "GET_COURSE_DETAILS_FAIL"
export const GET_COURSE_DETAILS_SUCCESS = "GET_COURSE_DETAILS_SUCCESS"
export const GET_STREAM_DETAILS_START = "GET_STREAM_DETAILS_START"
export const GET_STREAM_DETAILS_FAIL = "GET_STREAM_DETAILS_FAIL"
export const GET_STREAM_DETAILS_SUCCESS = "GET_STREAM_DETAILS_SUCCESS"
export const GET_YEAR_AND_SEMESTER_DETAILS_START = "GET_YEAR_AND_SEMESTER_DETAILS_START"
export const GET_YEAR_AND_SEMESTER_DETAILS_FAIL = "GET_YEAR_AND_SEMESTER_DETAILS_FAIL"
export const GET_YEAR_AND_SEMESTER_DETAILS_SUCCESS = "GET_YEAR_AND_SEMESTER_DETAILS_SUCCESS"


